import type { ComboboxOption } from '../../components/Combobox';
import type { CustomerListItem } from './api';

/** Macht aus einem Kunden einen Eintrag der Auswahlliste. */
export function customerOption(
  customer: Pick<CustomerListItem, 'id' | 'name' | 'customer_number' | 'status'>,
  inactiveLabel?: string,
): ComboboxOption {
  return {
    id: customer.id,
    label: customer.name,
    meta: customer.customer_number,
    hint: customer.status !== 'active' ? inactiveLabel : undefined,
  };
}
